class FaviconUpdater {
  constructor() {
    this.originalFavicon = null;
  }

  updateFavicon(showRedDot) {
    const favicon = document.querySelector('link[rel="icon"]');
    if (!favicon) return;

    if (!this.originalFavicon) {
      this.originalFavicon = favicon.href; // Store original favicon
    }

    if (!showRedDot) {
      favicon.href = this.originalFavicon; // Restore original favicon
      return;
    }

    const img = new Image();
    img.src = this.originalFavicon;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const size = 32;
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');

      // Draw existing favicon
      ctx.drawImage(img, 0, 0, size, size);

      // Draw red dot
      ctx.fillStyle = '#dc3545';
      ctx.beginPath();
      ctx.arc(26, 8, 6, 0, 2 * Math.PI);
      ctx.fill();

      // Convert canvas to data URL and update favicon href
      favicon.href = canvas.toDataURL('image/png');
    };
  }
}

export default {
  install(Vue) {
    Vue.prototype.$faviconUpdater = new FaviconUpdater();
  }
};
